import { trustSteps } from '@/mocks/playgroundData';
import { useInView } from '@/hooks/useInView';

function Step({ step, delay, isLast }: { step: typeof trustSteps[0]; delay: number; isLast: boolean }) {
  const [ref, inView] = useInView<HTMLDivElement>();

  return (
    <div
      ref={ref}
      className={`relative flex flex-col items-center text-center transition-all duration-700 ${
        inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {!isLast && (
        <div className="hidden lg:block absolute top-9 left-[62%] w-[76%] h-px bg-gradient-to-r from-primary-300 to-transparent" />
      )}
      <div className="relative mb-4">
        <div className="w-20 h-20 rounded-2xl bg-primary-100 flex items-center justify-center">
          <i className={`${step.icon} text-2xl md:text-3xl text-primary-700`} />
        </div>
        <div className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-accent-500 flex items-center justify-center">
          <span className="text-xs font-bold text-background-50">{step.number}</span>
        </div>
      </div>
      <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-1.5">
        {step.title}
      </h3>
      <p className="text-sm text-foreground-600 leading-relaxed max-w-[200px]">
        {step.description}
      </p>
    </div>
  );
}

export default function ProtectTrust() {
  const [ref, inView] = useInView<HTMLDivElement>();

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-100">
      <div
        ref={ref}
        className={`text-center max-w-2xl mx-auto mb-12 md:mb-16 transition-all duration-700 ${
          inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        <h2
          className="text-3xl md:text-4xl font-bold text-foreground-950 leading-tight mb-3"
          style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}
        >
          How a bioStamp Protects Trust
        </h2>
        <p className="text-base md:text-lg text-foreground-600">
          A biometric identity, cryptographically bound, verified by the recipient.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6 mb-10">
        {trustSteps.map((step, i) => (
          <Step key={step.id} step={step} delay={i * 120} isLast={i === trustSteps.length - 1} />
        ))}
      </div>

      <div className="max-w-4xl mx-auto flex items-center gap-4 p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70">
        <div className="w-11 h-11 shrink-0 flex items-center justify-center rounded-xl bg-primary-100 text-primary-700">
          <i className="ri-shield-check-line text-xl" />
        </div>
        <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
          bioMail protects message privacy — the bioStamp helps verify sender identity and protected
          message information.
        </p>
      </div>
    </section>
  );
}